
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Rating from '@/components/elements/rating/Rating.vue';
import { Options, Vue, setup } from 'vue-class-component';
import SideOver from '@/components/elements/sideOver/SideOver.vue';
import { useStore } from 'vuex';
import { useWeeklyReportList } from '@/features/weeklyReport/weeklyReportList';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading.vue';
import SlideOverWeekFilter from '@/views/report/features/week/SlideOverWeekFilter.vue';
import Loading from '@/components/common/Loading.vue';
import { Watch } from 'vue-property-decorator';
import { $api } from '@/services';
import { _ROUTER_NAME } from '@/enums';
import { useStudent } from '@/features/student/useStudent';
import { useGetEmployees } from '@/views/record/employee/services/getEmployees';
import { isLitePackage } from '@/helper/packageTier';
import store from '@/store';
@Options({
	name: 'ReportWeek',
	components: {
		Loading,
		SlideOverWeekFilter,
		SideOver,
		Rating,
		DaIcon,
		DaInfinityLoading,
	},
	props: {
		openFilter: {
			type: Number,
			default: 0,
		},
	},
})
export default class ReportWeek extends Vue {
	weeklyReportList: any = [];
	beforeDate = '';
	stopLoad = false;
	isInfinityLoading = false;
	isLoading = true;
	isHides: any = [];
	payload: any = null;
	sideOverShow = false;
	students: any = [];
	staffs: any = [];
	filterOptionsLoaded = false;
	filterOptionsLoading = false;

	setup = setup(() => {
		const store = useStore();
		const { error, loading, getWeeklyReportList } = useWeeklyReportList();
		const { getSimpleStudents } = useStudent();
		const { getSimpleStaffs } = useGetEmployees();
		return {
			store,
			error,
			loading,
			getWeeklyReportList,
			getSimpleStudents,
			getSimpleStaffs,
		};
	});

	get isLitePackage() {
		return isLitePackage(store.state.profile);
	}

	get isAdmin() {
		return this.setup.store.getters.isAdmin;
	}

	get weeklyReports() {
		return this.weeklyReportList;
	}

	get store() {
		return this.setup.store;
	}

	@Watch('openFilter')
	onOpenFilter(val: number) {
		if (val) {
			this.sideOverShow = true;
			this.loadFilterOptions();
		}
	}

	@Watch('$route.query', {
		deep: true,
		immediate: true,
	})
	onRouteChange(value: any) {
		if (this.$route.name !== _ROUTER_NAME.REPORT_WEEK_CLASS) return;
		this.payload = {
			...this.payload,
			state: value?.state,
			student_id: value?.student_id,
			staff_id: value?.staff_id,
			week_start: value?.week_start,
		};
		this.weeklyReportList = [];
		this.beforeDate = '';
		this.payload = {
			...this.payload,
			before: undefined,
		};
		this.getWeeklyReports();
	}

	showHide(date: any) {
		const index = this.isHides.indexOf(date);
		if (index !== -1) {
			this.isHides.splice(index, 1);
		} else {
			this.isHides.push(date);
		}
	}

	async loadFilterOptions() {
		if (this.filterOptionsLoaded || this.filterOptionsLoading) return;
		this.filterOptionsLoading = true;
		try {
			const [studentsRes, staffsRes] = await Promise.all([
				this.setup.getSimpleStudents(),
				this.setup.getSimpleStaffs(),
			]);
			this.students = studentsRes?.data || [];
			this.staffs = staffsRes?.data || [];
			this.filterOptionsLoaded = !!studentsRes && !!staffsRes;
		} finally {
			this.filterOptionsLoading = false;
		}
	}

	async getWeeklyReports() {
		const res = await this.setup.getWeeklyReportList(
			this.beforeDate
				? {
						...this.payload,
						before: this.beforeDate,
						// eslint-disable-next-line no-mixed-spaces-and-tabs
				  }
				: this.payload
		);

		this.isInfinityLoading = true;
		if (res?.data && res?.data.length > 0) {
			this.weeklyReportList.push({
				date:
					res?.week_start ||
					res?.data[res?.data.length - 1].week_start,
				data: res?.data,
				stats: res?.stats,
			});
			this.beforeDate =
				res?.week_start || res?.data[res?.data.length - 1].week_start;
		} else {
			this.stopLoad = true;
		}
		this.isLoading = false;
	}

	async sendReport(student_id: any, id: any) {
		try {
			await $api.weeklyReport.sendReport(student_id, id);
			await this.store.dispatch('setAlertMessage', {
				message: 'Đã gửi báo cáo thành công',
			});
			setTimeout(() => {
				location.reload();
			}, 500);
		} catch (e) {
			await this.store.dispatch('setAlertMessage', {
				message: 'Cõ lỗi xảy ra, vui lòng thử lại.',
				type: 'danger',
			});
		}
	}

	clean(obj: any) {
		for (let propName in obj) {
			if (
				obj[propName] === null ||
				obj[propName] === undefined ||
				obj[propName].length <= 0
			) {
				delete obj[propName];
			}
		}
		return obj;
	}

	async submitFilter(value: any) {
		this.clean(value);
		this.$router.push({
			query: value,
		});
		this.sideOverShow = false;
	}

	async cancelFilter() {
		this.$router.push({
			query: {},
		});
		this.sideOverShow = false;
	}

	beforeDestroy() {
		this.isInfinityLoading = false;
	}
}
